/* eslint-disable no-console */
import axios from "../axios";
import _isEmpty from "lodash/isEmpty";
import _entries from "lodash/entries";

// Copy template file
const copyFile = (fileUrl, folder) => {
  const response = axios.post(`/files/copy-file`, { fileUrl, folder });
  return response;
};

const uploadFile = (file, folder) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", folder);
  return axios.post(`/files/upload`, formData);
};

const deleteFiles = (files) => axios.post(`/files/delete-files`, { files });

const deleteFile = ({ fileName, folder }) =>
  axios.post(`/files/delete`, { fileName, folder });

const handleFilesUpload = async (
  files,
  currentOfficial = null,
  isEditing = false,
  folder = "images"
) => {
  let filesWithValues = {};

  /** Handle files that have values of type String */
  _entries(files)
    .filter((file) => typeof file[1] === "string")
    .map(([fileName, file]) => {
      if (file) {
        filesWithValues[fileName] = file;
      }
    });

  /** Handle files that have value of type file */
  let uploadedFiles = await new Promise((resolve) => {
    const filesToUpload = _entries(files).filter(
      (file) => typeof file[1] !== "string"
    );
    if (!_isEmpty(filesToUpload)) {
      (async () => {
        let uploadedFiles = {};
        try {
          await Promise.all(
            filesToUpload.map(async ([fileName, file]) => {
              if (file) {
                const { data } = await uploadFile(file, folder);
                uploadedFiles = { ...uploadedFiles, [fileName]: data };
              }
            })
          );
          // if (isEditing) {
          //   const filesToDelete = filesToUpload
          //     .map(([fileName]) => currentOfficial?.fileUploads[fileName])
          //     .filter(Boolean)
          //   if (filesToDelete.length > 0) await deleteFiles(filesToDelete)
          // }
          resolve(uploadedFiles);
        } catch (error) {}
      })();
    } else resolve();
  });

  uploadedFiles = {
    ...filesWithValues,
    ...uploadedFiles,
  };

  return uploadedFiles;
};

export { deleteFiles, handleFilesUpload, copyFile, deleteFile };
